import React, { useMemo } from 'react'
import { createStore, Store } from 'effector'
import { createGlobalStyle, css } from 'styled-components'
import { useStore } from 'effector-react'

import {
	allColorShades,
	ColorsSchemeNames,
	excludeColorShades,
} from '../../atoms'

const colorList = excludeColorShades(['gradient'])

type DataColorApplyProps = {
	$theme?: Store<{
		[key: string]: any
		colors: Record<string, string>
	}>
}

export const DataColorApply = ({ $theme }: DataColorApplyProps) => {
	const theme = useStore($theme || createStore(null))

	const colors = useMemo(() => {
		if (theme?.colors) return theme.colors

		return colorList.reduce(
			(result: Record<ColorsSchemeNames, string>, colorName) => ({
				...result,
				[colorName]: allColorShades[colorName],
			}),
			{} as Record<ColorsSchemeNames, string>
		)
	}, [theme?.colors])
	return <GlobalStyle colors={colors} />
}

const createCss = ({
	colors,
}: {
	colors: Record<ColorsSchemeNames, string>
}) => {
	let strResult = ''
	colorList.forEach(key => {
		strResult += `[data-color="${key}"]{color: ${colors[key]};}`
	})
	return css`
		${strResult}
	`
}

const GlobalStyle = createGlobalStyle<{
	colors: Record<ColorsSchemeNames, string>
}>`
${createCss}
`
